import { Banner, SimpleModal, Box } from '@sequencehq/core-components'
import { FC } from 'react'

export const MarkAsShippingContactDialog: FC<{
  title: string
  previousShippingContactEmail?: string
  isOpen: boolean
  onClose: () => void
  onConfirm: () => Promise<void>
}> = ({ title, previousShippingContactEmail, isOpen, onClose, onConfirm }) => {
  return (
    <SimpleModal
      data-testid="contacts.markShippingDialog"
      variant="dialog"
      disableSubmitOnEnter
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      cancelButtonText="Cancel"
      submitButtonText="Continue"
      onSubmit={async () => {
        await onConfirm()
        return true
      }}
    >
      <Box mb={previousShippingContactEmail ? 4 : 0}>
        The shipping contact always receives invoice notifications and payment
        reminders.
      </Box>
      {previousShippingContactEmail && (
        <Banner
          variant="neutral"
          data-testid="contacts.markShippingDialog.replaces"
        >
          This replaces {previousShippingContactEmail} as the shipping contact.
        </Banner>
      )}
    </SimpleModal>
  )
}
